export default {
  cardLabel: {
    id: 'landing_coming_soon_card_label',
    defaultMessage: "Don't buy the hype",
  },
  priceStartAt: {
    id: 'landing_coming_soon_price_start_at',
    defaultMessage: 'Starting at:',
  },
  price: {
    id: 'landing_coming_soon_price',
    defaultMessage: '$#!@',
  },
  strikedPrice: {
    id: 'landing_coming_soon_price_striked',
    defaultMessage: 'Worth the update',
  },
}
